<div class="container">
	<div class="item-panel">
		<div class="heading strong"><b>CONFIGURATION MANAGEMENT</b></div>
		<div class="content">
			<div class="row">
				<div class="col-lg-12">
					Asset Configurations define the relationship between sensors and components, and also define the how
					information from components is used to assert knowledge about the health of the component. Asset
					Configurations can be applied to multiple assets of the same type.
				</div>
			</div>
		</div>
		<div class="content nopad">
			<ul ngbNav #nav="ngbNav" class="nav-tabs dark">
				<li ngbNavItem>
					<a ngbNavLink>Manage configs</a>
					<ng-template ngbNavContent>
						<app-manage-config></app-manage-config>
					</ng-template>
				</li>
				<li ngbNavItem>
					<a ngbNavLink>Add templated config</a>
					<ng-template ngbNavContent>
						<app-templated-config></app-templated-config>
					</ng-template>
				</li>
				<li ngbNavItem>
					<a ngbNavLink>Add raw config</a>
					<ng-template ngbNavContent>
						<app-add-raw-config></app-add-raw-config>
					</ng-template>
				</li>
				<li ngbNavItem>
					<a ngbNavLink>Thresholding</a>
					<ng-template ngbNavContent>
						<app-thresholding></app-thresholding>
					</ng-template>
				</li>
				<li ngbNavItem *ngIf="api.user.role === 'master'">
					<a ngbNavLink>Manage templates (MASTER)</a>
					<ng-template ngbNavContent>
						<app-manage-templates></app-manage-templates>
					</ng-template>
				</li>
			</ul>
			<div [ngbNavOutlet]="nav"></div>
		</div>
	</div>
</div>